import '../styles/footer.css'

const Footer = () => {
    return (
        <div className='footer'>
            <ul>
                <li>
                    <a href="/#about-us">About Us</a>
                </li>
            </ul>
            <p>by SPARTANS HMIF 2021 made with ❤️</p>
        </div>
    )
}

export default Footer;